import { MessageCircle, ArrowUpRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { PA_BASE, waLink } from "../config";
import { EnquiryForm } from "../components/EnquiryForm";
import { Reveal, Overline } from "../components/motion";
import { Link } from "react-router-dom";

export default function ContactPage() {
  return (
    <section className="bg-[#F9F9F6] pb-28 pt-36 sm:pt-44" data-testid="contact-page">
      <Seo
        title="Contact the Charter Desk | JS Private Aviation"
        description="Speak with a charter specialist — every enquiry is reviewed personally. WhatsApp +44 7459 103218 or send an enquiry."
      />
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal>
          <Overline>Contact</Overline>
          <h1 className="mt-4 max-w-3xl font-display text-4xl tracking-tight sm:text-5xl lg:text-6xl leading-[1.02]">
            Speak with the charter desk.
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-black/60">
            Every enquiry is reviewed personally by our charter team. Use the form, or message us directly
            on WhatsApp — whichever suits the moment.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-12 lg:grid-cols-12">
          <Reveal delay={0.1} className="lg:col-span-4">
            <div className="space-y-6">
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-card"
                className="group block border border-black/10 bg-white p-8 transition-shadow duration-300 hover:shadow-[0_16px_40px_rgba(0,0,0,0.07)]"
              >
                <MessageCircle size={20} className="text-black/70" />
                <h2 className="mt-4 font-display text-xl tracking-tight">WhatsApp</h2>
                <p className="mt-2 text-sm leading-relaxed text-black/55">
                  The fastest route to a charter specialist — routes, dates and questions, in one message.
                </p>
                <span className="mt-4 inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.2em] text-black/50 transition-colors duration-300 group-hover:text-black">
                  Open WhatsApp <ArrowUpRight size={13} />
                </span>
              </a>

              <div className="border border-black/10 bg-white p-8" data-testid="contact-process-card">
                <h2 className="font-display text-xl tracking-tight">What happens next</h2>
                <ol className="mt-4 space-y-3 text-sm leading-relaxed text-black/55">
                  <li className="flex gap-3"><span className="font-mono text-[10px] text-black/30">01</span> Your enquiry reaches the charter team.</li>
                  <li className="flex gap-3"><span className="font-mono text-[10px] text-black/30">02</span> We source suitable aircraft through our operator network.</li>
                  <li className="flex gap-3"><span className="font-mono text-[10px] text-black/30">03</span> You receive considered options with transparent quotes.</li>
                </ol>
              </div>

              <div className="border border-black/10 bg-white p-8" data-testid="contact-corporate-card">
                <h2 className="font-display text-xl tracking-tight">Corporate programmes</h2>
                <p className="mt-2 text-sm leading-relaxed text-black/55">
                  For recurring business travel and roadshows, see our corporate aviation page.
                </p>
                <Link
                  to={`${PA_BASE}/corporate`}
                  className="mt-4 inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.2em] text-black/50 transition-colors duration-300 hover:text-black"
                >
                  Corporate aviation <ArrowUpRight size={13} />
                </Link>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.18} className="lg:col-span-8">
            <EnquiryForm source="contact-page" title="Send an enquiry" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
